











import { defineComponent, computed } from '@vue/composition-api';

const CommonDistrictSelector = defineComponent({
  setup(props: any) {
    const itemsId = computed(() => {
      if (!props.list) return [];
      const temp: string[] = [];
      props.list.forEach((item: any) => {
        temp.push(item.id);
      });
      return temp;
    });
    const itemsName = computed(() => {
      if (!props.list) return [];
      const temp: string[] = [];
      props.list.forEach((item: any) => {
        temp.push(item.name);
      });
      return temp;
    });

    const _value = computed(() => props.value);

    return {
      itemsId,
      itemsDisplay: itemsName,
      _value,
    };
  },
  props: {
    label: {
      type: String,
      default() { return 'ตำบล'; },
    },
    value: {
      type: [String, Number],
      default() { return ''; },
    },

    list: {
      type: Array,
      default() { return ['โปรดเลือกอำเภอ']; },
    },
  },
});

export default CommonDistrictSelector;
